import React, { useContext } from 'react'

import { Navigate, Outlet } from 'react-router-dom'
import { UserContext } from '../../context/users/UserContext'

export default function PrivateRoute() {
	const userCtx = useContext(UserContext)

	const { authStatus, isVerifying } = userCtx

	// Esperar a que termine la verificación antes de redirigir
	if (isVerifying) {
		return <div>Cargando...</div> // O un componente de loading
	}

	return authStatus ? <Outlet /> : <Navigate to='/iniciar-sesion' replace />
}
